import {isObj} from 'ramda-adjunct';

export function isFile(file: unknown): file is File {
  return isObj(file) && !!('name' in File);
}
